import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { apiComuni } from "../../auth/form-sign-up/utils/registerAPI";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Form = ({ form, setForm, province, toponomie, TipologiaAziende }) => {
  const [comuni, setComuni] = useState([]);
  const [cap, setCap] = useState([]);

  const tipologie = [
    { value: "societa", label: "Società" },
    { value: "ditta", label: "Ditta Individuale" },
    { value: "persona", label: "Persona Fisica" },
  ];

  const handleComuni = (provinciaSigla) => {
    apiComuni(provinciaSigla).then((response) => setComuni(response.data[0]));
  };

  const handleCap = (comuneCodice) => {
    const comune = comuni.find((el) => el.codice === comuneCodice);

    if (!comune) return;

    const capList = comune.cap || [];

    // Update the CAP list in state
    setCap(capList);

    // ✅ If there’s only one CAP, automatically set it in the form
    if (capList.length === 1) {
      setForm((prev) => ({
        ...prev,
        residenzaSedeLegale: {
          ...prev.residenzaSedeLegale,
          cap: capList[0],
        },
      }));
    }
  };

  return (
    <Box>
      <Grid
        container
        spacing={3}
        mb={4}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={4} xs={12}>
          <FormControl size="small" margin="none" fullWidth>
            <InputLabel id="forma-giuridica-label">Forma Giuridica</InputLabel>
            <Select
              labelId="forma-giuridica-label"
              id="forma-giuridica"
              name="forma-giuridica"
              label="Forma Giuridica"
              value={form.formaGiuridica}
              MenuProps={MenuProps}
              onChange={(e) => {
                setForm({
                  ...form,
                  formaGiuridica: e.target.value,
                  tipoSocieta: e.target.value === "ditta" ? 64 : 1,
                  cognomeRagioneSociale: "",
                  nome: "",
                  cf: "",
                  piva: "",
                  residenzaSedeLegale: {
                    provincia: "",
                    comune: "",
                    cap: "",
                    viacorso: "",
                    indirizzo: "",
                    civico: "",
                  },
                  email: "",
                  cellulare: "",
                  targa: "",
                });
              }}
            >
              {tipologie.map((tipo) => (
                <MenuItem key={tipo.value} value={tipo.value}>
                  {tipo.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        mb={4}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        {form.formaGiuridica !== "persona" && (
          <Grid item sm={4} xs={12}>
            <FormControl size="small" required fullWidth margin="none">
              <InputLabel id="tipoSocieta-label">Tipo Società</InputLabel>
              <Select
                labelId="tipoSocieta-label"
                id="tipoSocieta"
                name="tipoSocieta"
                label="Tipo Società"
                value={form.formaGiuridica === "ditta" ? 65 : form.tipoSocieta}
                MenuProps={MenuProps}
                onChange={(e) =>
                  setForm({ ...form, tipoSocieta: e.target.value })
                }
                disabled={form.formaGiuridica === "ditta"}
              >
                <MenuItem value={0}></MenuItem>
                {TipologiaAziende.map((tipologia) => (
                  <MenuItem key={tipologia.id} value={tipologia.id}>
                    {tipologia.descrizioneAzienda} ({tipologia.tipoAzienda})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {form.formaGiuridica === "societa" ||
        form.formaGiuridica === "ditta" ? (
          <Grid item sm={4} xs={12}>
            <TextField
              size="small"
              margin="none"
              label="Ragione Sociale"
              required
              fullWidth
              value={form.cognomeRagioneSociale}
              id="ragioneSociale"
              onChange={(e) =>
                setForm({ ...form, cognomeRagioneSociale: e.target.value })
              }
            />
          </Grid>
        ) : (
          <>
            <Grid item sm={4} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Cognome"
                required
                fullWidth
                value={form.cognomeRagioneSociale}
                id="cognome"
                onChange={(e) =>
                  setForm({ ...form, cognomeRagioneSociale: e.target.value })
                }
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Nome"
                required
                fullWidth
                value={form.nome}
                id="nome"
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                /* error={state.errorNumeroPolizza} */
              />
            </Grid>
          </>
        )}
        {form.formaGiuridica === "societa" ||
        form.formaGiuridica === "ditta" ? (
          <>
            <Grid item sm={4} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Partita IVA"
                required
                fullWidth
                value={form.piva}
                id="piva"
                onChange={(e) => setForm({ ...form, piva: e.target.value })}
                /* error={state.errorNumeroPolizza} */
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Codice Fiscale"
                fullWidth
                value={form.cf}
                id="cf"
                onChange={(e) => setForm({ ...form, cf: e.target.value })}
                /* error={state.errorNumeroPolizza} */
              />
            </Grid>
          </>
        ) : (
          <Grid item sm={4} xs={12}>
            <TextField
              size="small"
              margin="none"
              label="Codice Fiscale"
              required
              fullWidth
              value={form.cf}
              id="cf"
              onChange={(e) => setForm({ ...form, cf: e.target.value })}
              /* error={state.errorNumeroPolizza} */
            />
          </Grid>
        )}
      </Grid>
      <Box marginTop={6}>
        <Typography variant="h4" display="inline">
          {form.formaGiuridica === "societa" || form.formaGiuridica === "ditta"
            ? "Sede Legale"
            : "Residenza"}
        </Typography>
      </Box>
      <Grid
        mt={1}
        container
        spacing={3}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={4} xs={12}>
          <Autocomplete
            size="small"
            fullWidth
            options={province}
            getOptionLabel={(option) => option.nome}
            value={
              province.find(
                (p) => p.sigla === form.residenzaSedeLegale.provincia
              ) || null
            }
            onChange={(_, newValue) => {
              setForm({
                ...form,
                residenzaSedeLegale: {
                  ...form.residenzaSedeLegale,
                  provincia: newValue ? newValue.sigla : "",
                  comune: "",
                  cap: "",
                },
              });
              if (newValue) handleComuni(newValue.sigla);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Provincia" required />
            )}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <Autocomplete
            size="small"
            fullWidth
            options={comuni}
            getOptionLabel={(option) => option.comune}
            value={
              comuni.find(
                (c) => c.codice === form.residenzaSedeLegale.comune
              ) || null
            }
            onChange={(_, newValue) => {
              setForm({
                ...form,
                residenzaSedeLegale: {
                  ...form.residenzaSedeLegale,
                  comune: newValue ? newValue.codice : "",
                  cap: "",
                },
              });
              if (newValue) handleCap(newValue.codice);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Comune" required />
            )}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <FormControl
            size="small"
            fullWidth
            margin="none"
            required /* error={Boolean(errors.datiResponsabile.provincia)} */
          >
            <InputLabel id="cap-label">CAP</InputLabel>{" "}
            <Select
              labelId="cap-label"
              id="cap"
              name="cap"
              label="CAP"
              value={form.residenzaSedeLegale.cap}
              MenuProps={MenuProps}
              onChange={(e) => {
                setForm({
                  ...form,
                  residenzaSedeLegale: {
                    ...form.residenzaSedeLegale,
                    cap: e.target.value,
                  },
                });
              }}
            >
              {cap.map((el, i) => (
                <MenuItem key={i} value={el}>
                  {el}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={4} xs={12}>
          <Autocomplete
            size="small"
            fullWidth
            options={toponomie}
            getOptionLabel={(option) => option.name}
            value={
              toponomie.find(
                (t) => t.value === form.residenzaSedeLegale.viacorso
              ) || null
            }
            onChange={(e) => {
              setForm({
                ...form,
                residenzaSedeLegale: {
                  ...form.residenzaSedeLegale,
                  viacorso: e.target.value,
                },
              });
            }}
            renderInput={(params) => (
              <TextField {...params} label="Via, Corso" required />
            )}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Indirizzo"
            fullWidth
            value={form.residenzaSedeLegale.indirizzo}
            id="indirizzo"
            onChange={(e) =>
              setForm({
                ...form,
                residenzaSedeLegale: {
                  ...form.residenzaSedeLegale,
                  indirizzo: e.target.value,
                },
              })
            }
            required
            /*  error={Boolean(errors.datiResponsabile.indirizzo)}
                      helperText={errors.datiResponsabile.indirizzo} */
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Civico"
            fullWidth
            value={form.residenzaSedeLegale.civico}
            id="civico"
            onChange={(e) =>
              setForm({
                ...form,
                residenzaSedeLegale: {
                  ...form.residenzaSedeLegale,
                  civico: e.target.value,
                },
              })
            }
            required
            /*  error={Boolean(errors.datiResponsabile.indirizzo)}
                      helperText={errors.datiResponsabile.indirizzo} */
          />
        </Grid>
      </Grid>
      <Box marginTop={6}>
        <Typography variant="h4" display="inline">
          Altri dati
        </Typography>
      </Box>
      <Grid
        mt={1}
        container
        spacing={3}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={4} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Email"
            fullWidth
            value={form.email}
            id="email"
            onChange={(e) =>
              setForm({
                ...form,
                email: e.target.value,
              })
            }
            required
            /*  error={Boolean(errors.datiResponsabile.indirizzo)}
                      helperText={errors.datiResponsabile.indirizzo} */
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Cellulare"
            fullWidth
            value={form.cellulare}
            id="cellulare"
            onChange={(e) =>
              setForm({
                ...form,
                cellulare: e.target.value,
              })
            }
            required
            /*  error={Boolean(errors.datiResponsabile.indirizzo)}
                      helperText={errors.datiResponsabile.indirizzo} */
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <TextField
            size="small"
            margin="none"
            label="Targa"
            fullWidth
            value={form.targa}
            id="targa"
            onChange={(e) =>
              setForm({
                ...form,
                targa: e.target.value,
              })
            }
            required
            /*  error={Boolean(errors.datiResponsabile.indirizzo)}
                      helperText={errors.datiResponsabile.indirizzo} */
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Form;
